export default __webpack_public_path__ + "static/media/warning--tunnel--g7.cdca6a34.png";